import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ProfileService extends RestfulService<Models.Profile> {

  constructor(private restService: RestService) {
    super(Models.Profile);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('profiles');
  }

}
